<template>
  <div>
    <div>
      <div class="d-flex">
        <div v-if="NavbarVertical && permisoVisualizador != 11" class="mx-2" :class="aboutClass">
          <div :class="{
            'mx-2 mt-1 text-center': !ocultar,
            ' text-center ms-3': ocultar,
          }">
            <img @click="ocultarNavbar" src="@/assets/responsive.svg" alt="" />
          </div>
          <nav class="px-0">
            <ul class="nav flex-column">
              <li class="nav-item w-100 text-center">
                <router-link to="/dashboard" class="text-decoration-none">
                  <div class="d-flex mt-1 pt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" :class="{
                      'bi bi-house mb-1 pt-2  mx-auto  color ': !ocultar,
                      'bi bi-house mb-1 pt-2 ms-3 color ': ocultar,
                    }" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" />
                      <path fill-rule="evenodd"
                        d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" />
                    </svg>
                    <p v-if="ocultar" class="pt-2 my-auto tamaño w-100 ms-2">
                      INICIO
                    </p>
                  </div>
                </router-link>
              </li>
            </ul>

            <ul class="nav flex-column text-left">
              <li v-for="(item, index) in Items" :key="index.id" class="nav-item decorar">
                <div class="d-flex mt-2 bg-solimano w-100">
                  <i :class="[
                    {
                      ' mt-1 text-white fs-5 mb-1 mx-auto': !ocultar,
                      ' mt-1 text-white  fs-5 mb-1 ms-3': ocultar,
                    },
                    IconoModulo[index],
                  ]"></i>

                  <p v-if="ocultar" class="my-auto tamaño w-100 ms-3 text-white">
                    {{ item }}
                  </p>
                </div>

                <ul class="enlaces" v-for="(categoria, index) in ModuloRapido" :key="index.id">
                  <p class="text-decoration-none tamaño py-0 my-2" :class="{
                    'categoria-seleccionada': categoriaSeleccionada === index,
                  }" @click="seleccionarCategoria(index)">
                    <router-link v-if="
                      categoria.modNombre === item &&
                      categoria.catplataform == Plataforma
                    " class="text-decoration-none tamaño" :to="categoria.idCategoria == 20
                          ? {
                            name: categoria.idCategoria,
                            params: { contrato: idSolxPostulante },
                          }
                          : categoria.idCategoria == 27
                            ? {
                              name: categoria.idCategoria,
                              params: { use: idSolxPostulante },
                            }
                            : categoria.idCategoria == 26 ||
                              categoria.idCategoria == 18
                              ? {
                                name: categoria.idCategoria,
                                params: { idSol: idSolxPostulante },
                              }
                              : categoria.idCategoria == 32 ||
                                categoria.idCategoria == 33 ||
                                categoria.idCategoria == 34 ||
                                categoria.idCategoria == 35 ||
                                categoria.idCategoria == 36 ||
                                categoria.idCategoria == 37 ||
                                categoria.idCategoria == 39 ||
                                categoria.idCategoria == 29 ||
                                categoria.idCategoria == 50
                                ? { path: '/SeguimientoSolicitud' }
                                : categoria.idCategoria == 17 ||
                                  categoria.idCategoria == 19 ||
                                  categoria.idCategoria == 23 ||
                                  categoria.idCategoria == 24 ||
                                  categoria.idCategoria == 89
                                  ? { path: '/gestionSolicitudes' }
                                  : categoria.idCategoria == 43 ||
                                    categoria.idCategoria == 44 ||
                                    categoria.idCategoria == 63 ||
                                    categoria.idCategoria == 88
                                    ? { path: '/SeguimientoRenovacion' }
                                    : categoria.idCategoria == 41 ||
                                      categoria.idCategoria == 62
                                      ? { path: '/RegistroRenovaciones' }
                                      : categoria.idCategoria == 55 ||
                                        categoria.idCategoria == 52 ||
                                        categoria.idCategoria == 105

                                        ? { path: '/GestionCese' }
                                        : categoria.idCategoria == 51 ||
                                          categoria.idCategoria == 54 ||
                                          categoria.idCategoria == 53 ||
                                            categoria.idCategoria == 104
                                          ? { path: '/RegistroCeseInd' }
                                          : categoria.idCategoria == 61 ||
                                            categoria.idCategoria == 66 ||
                                            categoria.idCategoria == 65 ||
                                            categoria.idCategoria == 76 
                                          ? { path: '/DescuentoTecnologia' }
                                          : categoria.idCategoria == 77
                                          ? { path: '/CorreosTecnologia' }
                                              //  : categoria.idCategoria == 79 ||
                                              //   categoria.idCategoria == 67
                                              //  ? {path: '/PuntosDeVenta'}
                                              //  : categoria.idCategoria == 80 ||
                                              //   categoria.idCategoria == 68
                                              //  ? {path: '/Horarios'}
                                              //  : categoria.idCategoria == 69 ||
                                              //   categoria.idCategoria == 81
                                              //  ? {path: '/Ruta'}
                                              //  : categoria.idCategoria == 70 ||
                                              //   categoria.idCategoria == 82
                                              //  ? {path: '/ControlAsistencia'}



                                              //Horarios , Ruta , ControlAsistencia


                                           : { name: categoria.idCategoria }
                        ">
                      <div @click="getAttributes" class="d-flex">
                        <i :class="[
                          { 'mx-auto': !ocultar, 'ms-2': ocultar },
                          categoria.desIcono,
                          'fs-5',
                        ]"></i>
                        <p v-if="ocultar" class="my-auto tamaño w-100 ms-3">
                          {{ categoria.catNombre }}
                        </p>
                      </div>
                    </router-link>
                  </p>
                </ul>
              </li>
            </ul>
          </nav>
        </div>

        <router-view> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SolimanoextranetAboutView",
  components: {},

  data() {
    return {
      url: "/",
      perfil: "",
      aboutClass: "wider-about",
      ocultar: false,
      categoriaSeleccionada: null,
      idSolxPostulante: null,
      permisoVisualizador: null,
    };
  },

  computed: {
    ...mapGetters("users", ["Items", "ModuloRapido", "IconoModulo"]),
    ...mapGetters("acciones", ["NavbarVertical", "Plataforma"]),
  },

  mounted() { },

  created() {
    this.getAttributes(), this.ParametrosUsers(), this.getAttributs();
    this.apiAttributes(), this.PlataformaCategoria()
    
    if(localStorage.getItem("idPerfil")== 10 || localStorage.getItem("idPerfil")== 12 ){
      this.getAttributesCitasPostulante(1);
    }

    this.idSolxPostulante = localStorage.getItem("idSolxPostulante");
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    if (localStorage.getItem("idPerfil") == 2 || localStorage.getItem("idPerfil") == 18) {
      this.getAttributesPostulante();
    }
  },
  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("parametros", ["ParametrosUsers"]),
    ...mapActions("listadoPostulante", ["getAttributesPostulante", "getAttributesCitasPostulante"]),
    ...mapActions("solicitudesListado", ["getAttributs", "apiAttributes"]),
    ...mapActions("acciones", ["PlataformaCategoria"]),

    cerrarSesion() {
      window.location.reload(true);
      localStorage.clear();
      this.$router.push("/");
    },

    seleccionarCategoria(index) {
      this.categoriaSeleccionada = index;
      console.log(index);
    },

    ocultarNavbar() {
      this.ocultar = !this.ocultar;
      this.aboutClass = !this.ocultar ? "wider-about" : "about";

      this.$store.dispatch("acciones/CambiosEstado", this.ocultar);
    },
  },
};
</script>

<style scoped>
.categoria-seleccionada {
  background-color: #d5fad5;
  /* Otros estilos personalizados si es necesario */
}

.check {
  display: none;
}

.modales {
  background: #002c5d;
  margin-top: 8%;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
  /*border-radius: 10px 10px 10px 10px;*/
  height: 40vh;
  color: white;
}

.wider-about {
  width: 4.5%;
  background: #ffffff;
  margin-left: 1%;
  margin-top: 9px;
  transition: 0.5s;
  overflow-y: auto;
  height: 100vh;
}

.about {
  background: #ffffff;
  width: 20% !important;
  height: 100vh;
  margin-left: 2%;
  margin-top: 9px;
  transition: 0.5s;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow-y: auto;
}


.about:hover {
  transition: 0.5s;
  margin-left: 20px;
  margin-top: 9px;
}

.aboute {
  background: #ffffff;
  width: 15%;
  height: 100vh;
  border-radius: 15px 15px 15px 15px;
  margin-left: 18px;
  margin-top: 9px;
  transition: 0.5s;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: none;
}

.aboute:hover {
  transition: 0.5s;
  margin-left: 20px;
  margin-top: 20px;
}

.decorar {
  text-align: left;
  font-size: 0.8rem;
  padding-left: 0px;
  font-weight: 500;
  color: #454854;
  font-weight: 800;
}

.decorar:hover {
  transition: 0.5s;
}

.enlaces {
  margin-left: 0%;
  padding-left: 2%;
}

.tamaño {
  font-size: 0.7rem;
  color: #155bac;
  font-weight: 700;
}

.bg-solimano {
  background: #155bac;
}

.color {
  color: #155bac;
}

li a {
  text-align: left;
  padding-left: 0px;
  font-weight: 800;
  color: #101111;
}

li a:hover {
  transition: all 0.5s;
  color: #3c74b4;
  font-size: 0.88rem;
}

.decoracion {
  list-style: none;
}
@media (max-width: 768px) {

  /* Cuando está CERRADO (solo icono) */
  .wider-about {
    width: 60px !important;   /* solo ícono */
    margin: 0 !important;
    height: 100vh !important;
  }

  /* Cuando está ABIERTO (pantalla completa) */
  .about {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 !important;         /* ← quita lo que te hacía que aparezca arriba */
    border-radius: 0 !important;
  }
}
</style>
